module.exports = __webpack_public_path__ + "static/media/career3.f8a3f056.jpg";